
export const discardChanges = (name, value, intl, accessManagement2NModal, modal) => {

  if (accessManagement2NModal.hasUnsavedChanges[name]) {
    modal.openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        type: 'error',
        title: intl.formatMessage({
          id: 'unsavedChanges',
        }),
        content: intl.formatMessage({
          id: 'unsavedChangesDescription',
        }),
        confirmLabel: intl.formatMessage({
          id: 'discard',
        }),
        cancelLabel: intl.formatMessage({
          id: 'stay',
        }),
        onConfirm: () => {
          modal.closeModal();
          accessManagement2NModal.setHasUnsavedChanges(name, false);
          accessManagement2NModal.updateSelected(name, value);
          accessManagement2NModal.updateAdding(name, false);
        },
      },
    });
  } else {
    accessManagement2NModal.updateSelected(name, value);
    accessManagement2NModal.updateAdding(name, false);
  }

};
